var _path, _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIndividualSide(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 256,
    height: 256,
    viewBox: "0 0 256 256",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8_63)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_8_63",
    style: {
      maskType: "luminance"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 256,
    height: 256
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M256 256V1.11901e-05L1.11901e-05 0L0 256H256Z",
    fill: "white"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_8_63)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 18,
    y: 58,
    width: 10,
    height: 140,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 228,
    y: 58,
    width: 10,
    height: 140,
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 58,
    y: 28,
    width: 10,
    height: 140,
    transform: "rotate(-90 58 28)",
    fill: "black"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 58,
    y: 238,
    width: 10,
    height: 140,
    transform: "rotate(-90 58 238)",
    fill: "black"
  })))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8_63"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 256,
    height: 256,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIndividualSide);
export default __webpack_public_path__ + "static/media/individual-side.295e29e2ae2eb4a8968d15afceb4be7a.svg";
export { ForwardRef as ReactComponent };